/** English strings — sector campaign, victory, achievements (docs/01). */
export const enSector = {
  // Sectors (config/sectors.ts)
  'sector.s1.name': 'SCRAP BELT',
  'sector.s1.tag': 'Salvage drones guard the old shipyard',
  'sector.s2.name': 'ELEMENTAL CORE',
  'sector.s2.tag': 'Fire, tide, stone, storm and void',
  'sector.s3.name': 'BROOD DEPTHS',
  'sector.s3.tag': 'Chains, tentacles and a hungry queen',
  'sector.s4.name': 'ANOMALY RIM',
  'sector.s4.tag': 'Where time and space stop behaving',
  'sector.label': 'SECTOR {n}',
  'sector.select': 'SELECT SECTOR',
  'sector.lockedHint': 'Clear Sector {n} to unlock',
  'sector.cleared': '✓ CLEARED',
  'sector.best': 'BEST {time}',
  'sector.notCleared': 'NOT CLEARED YET',
  'sector.finale': 'FINALE',
  'sector.rooms': '{n} ROOMS + FINALE',
  'sector.startWeapon': 'START WEAPON',
  'sector.pickSlot': 'SECTOR {n} — PICK A SLOT',
  'sector.hint.keyboard': '←/→ sector    ↑/↓ start weapon    Space play    Esc back',
  'sector.hint.gamepad': '←/→ sector    ↑/↓ start weapon    Ⓐ play    Ⓑ back',
  'sector.hint.touch': 'Tap a sector to play',

  // Title additions
  'title.play': 'PLAY',
  'title.endless': 'ENDLESS',
  'title.achievements': 'ACHIEVEMENTS',
  'title.pickEndless': 'ENDLESS — PICK A SLOT',
  'title.slotSector': 'SECTOR {s} · ROOM {room}/{total} · {cards} CARDS · {time}',
  'title.slotEndless': 'ENDLESS · ROOM {room} · {cards} CARDS · {runs} TRIES · {time}',

  // HUD + shop readouts
  'hud.sectorRoom': 'S{n} · ROOM {room}/{total}',
  'hud.sectorFinale': 'S{n} · FINALE',
  'hud.achievement': 'ACHIEVEMENT · {name}',
  'shop.sectorRoom': 'ROOM {room}/{total} · {arena}',
  'shop.sectorFinale': 'FINALE · {arena}',

  // Victory
  'victory.title': 'SECTOR CLEARED',
  'victory.time': 'CLEAR TIME',
  'victory.newBest': '★ NEW BEST',
  'victory.unlockedSector': 'SECTOR {n} UNLOCKED',
  'victory.unlockedEndless': 'ENDLESS MODE UNLOCKED',
  'victory.campaignDone': 'CAMPAIGN COMPLETE',
  'victory.earned': 'ACHIEVEMENTS EARNED',
  'victory.noneEarned': 'No new achievements this run',
  'victory.xp': '+{n} PILOT XP',
  'victory.next': 'NEXT SECTOR ▶',
  'victory.replay': 'PLAY AGAIN ▶',
  'victory.menu': 'MAIN MENU',

  // Sector lost (roguelike death)
  'sectorLost.where': 'SECTOR {n} LOST · ROOM {room}/{total}',
  'sectorLost.fresh': 'A retry starts from a fresh build: cards, weapons and gems reset.',
  'sectorLost.retry': 'RETRY SECTOR ▶',
  'runEnd.hint.keyboard': '←/→ select    Space confirm',
  'runEnd.hint.gamepad': '←/→ select    Ⓐ confirm',
  'runEnd.hint.touch': 'Tap a button',

  // Achievements (config/achievements.ts)
  'ach.title': 'ACHIEVEMENTS',
  'ach.progress': '{n}/{m} EARNED',
  'ach.reward.weapon': 'Start weapon: {name}',
  'ach.reward.card': 'New shop card: {name}',
  'ach.reward.endless': 'Unlocks ENDLESS mode',
  'ach.clear_s1.name': 'BELT BREAKER',
  'ach.clear_s1.desc': 'Clear Sector 1 — Scrap Belt',
  'ach.clear_s2.name': 'ELEMENT TAMER',
  'ach.clear_s2.desc': 'Clear Sector 2 — Elemental Core',
  'ach.clear_s3.name': 'QUEENSLAYER',
  'ach.clear_s3.desc': 'Clear Sector 3 — Brood Depths',
  'ach.clear_s4.name': 'TIMEBREAKER',
  'ach.clear_s4.desc': 'Clear Sector 4 — Anomaly Rim',
  'ach.untouchable.name': 'UNTOUCHABLE',
  'ach.untouchable.desc': 'Kill a boss without getting hit once it arrives',
  'ach.deathless.name': 'NO DEATHS',
  'ach.deathless.desc': 'Clear a sector without ever dying in it',
  'ach.blitz.name': 'BLITZ',
  'ach.blitz.desc': 'Clear a sector in under {m} minutes of fight time',
  'ach.arsenal.name': 'ARSENAL',
  'ach.arsenal.desc': 'Fire {n} weapons at once',
  'ach.topgun.name': 'TOP GUN',
  'ach.topgun.desc': 'Raise the gun tier to {n}',
  'ach.collector.name': 'COLLECTOR',
  'ach.collector.desc': 'Own {n} cards in one run',
} as const;
